document.addEventListener('DOMContentLoaded', function () {

  // scroll reveal
  var revealEls = document.querySelectorAll('.reveal');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { threshold: .15 });
  revealEls.forEach(function (el) { io.observe(el); });

  // mobile nav toggle
  var navToggle = document.getElementById('navToggle');
  var mobileNav = document.getElementById('mobileNav');
  if (navToggle && mobileNav) {
    navToggle.addEventListener('click', function () {
      navToggle.classList.toggle('open');
      mobileNav.classList.toggle('open');
    });
    mobileNav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        navToggle.classList.remove('open');
        mobileNav.classList.remove('open');
      });
    });
  }

  // cart badge: reflect the real Shopify cart item count
  var cartBadge = document.getElementById('cartBadge');
  function refreshCartBadge() {
    if (!cartBadge) return;
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (cart.item_count > 0) {
          cartBadge.textContent = cart.item_count;
          cartBadge.style.display = 'flex';
        } else {
          cartBadge.style.display = 'none';
        }
      })
      .catch(function () { /* ignore — badge just stays hidden */ });
  }
  refreshCartBadge();

  // remove item from cart (cart page)
  document.querySelectorAll('[data-remove-line]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var line = btn.dataset.removeLine;
      btn.disabled = true;
      var originalText = btn.textContent;
      btn.textContent = 'Removing…';

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: 0 })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('remove failed');
          return res.json();
        })
        .then(function () {
          window.location.reload();
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = originalText;
          showToast("Couldn't remove item", true);
        });
    });
  });

  // topbar shrink + sticky bar
  var topbar = document.getElementById('topbar');
  var stickyBar = document.getElementById('stickyBar');
  var hero = document.querySelector('.hero');
  window.addEventListener('scroll', function () {
    var y = window.scrollY;
    if (topbar) topbar.classList.toggle('shrink', y > 40);
    if (stickyBar && hero) stickyBar.classList.toggle('show', y > hero.offsetHeight);
  });

  // color swatches (pill style)
  var swatches = document.querySelectorAll('.swatch-pill');
  var heroImg = document.getElementById('hero-img');
  var stickyImg = document.getElementById('sticky-img');
  var selectedColor = document.getElementById('selected-color');

  swatches.forEach(function (sw) {
    sw.addEventListener('click', function () {
      swatches.forEach(function (s) { s.classList.remove('active'); });
      sw.classList.add('active');
      var src = sw.dataset.img;
      var label = sw.dataset.label;
      var variantId = sw.dataset.variantId;

      if (heroImg) {
        heroImg.style.opacity = 0;
        setTimeout(function () { heroImg.src = src; heroImg.style.opacity = 1; }, 220);
      }
      if (stickyImg) stickyImg.src = src;
      if (selectedColor) selectedColor.textContent = label;

      // update every add-to-cart button on the page to point at the selected variant
      document.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
        btn.dataset.variantId = variantId;
      });

      // keep the dynamic checkout button (PayPal/Shop Pay/Apple Pay/etc.) in sync
      var dynamicInput = document.getElementById('dynamicCheckoutVariantId');
      if (dynamicInput && variantId) {
        dynamicInput.value = variantId;
        dynamicInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });

  // gallery: swipeable + arrows + dots
  var galleryTrack = document.getElementById('galleryTrack');
  var gallerySlides = galleryTrack ? Array.prototype.slice.call(galleryTrack.children) : [];
  var galleryDots = document.getElementById('galleryDots');
  if (galleryTrack && gallerySlides.length) {
    gallerySlides.forEach(function (_, i) {
      var dot = document.createElement('button');
      dot.className = 'gallery-dot' + (i === 0 ? ' active' : '');
      dot.setAttribute('aria-label', 'Image ' + (i + 1));
      dot.addEventListener('click', function () {
        gallerySlides[i].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      });
      galleryDots.appendChild(dot);
    });
    var dots = Array.prototype.slice.call(galleryDots.children);
    var galObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var idx = gallerySlides.indexOf(e.target);
          dots.forEach(function (d) { d.classList.remove('active'); });
          if (dots[idx]) dots[idx].classList.add('active');
        }
      });
    }, { root: galleryTrack, threshold: 0.6 });
    gallerySlides.forEach(function (s) { galObserver.observe(s); });

    var scrollAmount = function () { return gallerySlides[0].getBoundingClientRect().width + 20; };
    var prevBtn = document.getElementById('galPrev');
    var nextBtn = document.getElementById('galNext');
    if (prevBtn) prevBtn.addEventListener('click', function () { galleryTrack.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }); });
    if (nextBtn) nextBtn.addEventListener('click', function () { galleryTrack.scrollBy({ left: scrollAmount(), behavior: 'smooth' }); });
  }

  // countdown timer (resets each page load — generic urgency nudge, adjust as needed)
  var countdownEl = document.getElementById('countdown-time');
  if (countdownEl) {
    var remaining = 2 * 60 * 60;
    function renderCountdown() {
      var h = String(Math.floor(remaining / 3600)).padStart(2, '0');
      var m = String(Math.floor((remaining % 3600) / 60)).padStart(2, '0');
      var s = String(remaining % 60).padStart(2, '0');
      countdownEl.textContent = h + ':' + m + ':' + s;
      remaining = remaining > 0 ? remaining - 1 : 2 * 60 * 60;
    }
    renderCountdown();
    setInterval(renderCountdown, 1000);
  }

  // accordion (FAQ + Legal, scoped independently)
  document.querySelectorAll('.faq-item').forEach(function (item) {
    var q = item.querySelector('.faq-q');
    if (!q) return;
    q.addEventListener('click', function () {
      var isOpen = item.classList.contains('open');
      var scope = item.closest('[id$="accordion"]') || document;
      scope.querySelectorAll('.faq-item').forEach(function (i) { i.classList.remove('open'); });
      if (!isOpen) item.classList.add('open');
    });
  });

  // toast helper
  function showToast(message, isError) {
    var toast = document.getElementById('toast');
    if (!toast) return;
    toast.querySelector('span').textContent = message;
    toast.classList.toggle('error', !!isError);
    toast.classList.add('show');
    clearTimeout(window._toastTimer);
    window._toastTimer = setTimeout(function () { toast.classList.remove('show'); }, 2800);
  }

  // ripple on any .btn
  function addRipple(btn) {
    var rect = btn.getBoundingClientRect();
    var ripple = document.createElement('span');
    ripple.className = 'ripple';
    ripple.style.left = (rect.width / 2 - 10) + 'px';
    ripple.style.top = (rect.height / 2 - 10) + 'px';
    ripple.style.width = ripple.style.height = '20px';
    btn.appendChild(ripple);
    setTimeout(function () { ripple.remove(); }, 650);
  }

  // real Shopify AJAX add-to-cart
  document.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var variantId = btn.dataset.variantId;
      if (!variantId) {
        showToast('Please select a color first', true);
        return;
      }
      addRipple(btn);
      btn.disabled = true;
      var originalText = btn.textContent;
      btn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('cart add failed');
          return res.json();
        })
        .then(function () {
          var colorNow = document.getElementById('selected-color');
          showToast('Tacet – ' + (colorNow ? colorNow.textContent : '') + ' added to cart');
          refreshCartBadge();
        })
        .catch(function () {
          showToast("Couldn't add to cart", true);
        })
        .finally(function () {
          btn.disabled = false;
          btn.textContent = originalText;
        });
    });
  });
});
